<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalContentsFireRate",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"19. (a) What is the Fire insurance rate on the contents of your premises?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0FireInsuranceRateId",
					props: {
						suggest: {
							typeIncludes: "fireInsuranceRate"
						},
						createOptions: {
							type: "fireInsuranceRate",
							dataType: "string"
						}
					}
				},
				{
					label: "19. (b) By whom was this quoted?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0FireInsuranceQuoteSourceId",
					props: {
						suggest: {
							typeIncludes: "fireInsuranceQuoteSource"
						},
						createOptions: {
							type: "fireInsuranceQuoteSource",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
